export const getOrganizationMembership = (user) => {
    // Check if the user data contains an organization
    // if plan = pro or agency, return the organization membership object
    if (user && user.organization && (user.organization.plan === 'pro' || user.organization.plan === 'agency')) {
      // Return the organization membership object
      return user.organization;
    } else {
      return null;
    }
  };